import styled from 'styled-components'
import CursorYellowHighlightPointerImage from './assets/cursor-yellow-highlight-pointer.png'
import CursorClearHighlightPointerImage from './assets/cursor-highlight-clear.png'

export const StyledHighlightableStimulusWrapper = styled.div`
  cursor: ${({ isHighlighterToolEnabled }) =>
    isHighlighterToolEnabled
      ? `url(${CursorYellowHighlightPointerImage}), auto`
      : 'unset !important'};

  my-highlight.text-highlight {
    cursor: ${({ isHighlighterToolEnabled }) =>
      isHighlighterToolEnabled
        ? `url(${CursorClearHighlightPointerImage}), auto`
        : 'unset !important'};
  }
`
